var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPageRightDis(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u53F3\u7BAD\u5934-dis@4x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u4E2A\\u4EBA\\u4E2D\\u5FC3-\\u8BA2\\u5355",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u56FE",
    transform: "translate(-671.000000, -3280.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u53F3\\u7BAD\\u5934-dis",
    transform: "translate(671.000000, 3280.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#0D47A0",
    opacity: 0.2,
    x: 0,
    y: 0,
    width: 20,
    height: 20,
    rx: 10
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    points: "3.0011996 3.00183468 16.824506 3.00183468 16.824506 16.8251411 3.0011996 16.8251411"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.04987903,7.68287298 C7.80798387,7.43469758 7.81108871,7.03883065 8.05926411,6.79383065 C8.30743952,6.55193548 8.70330645,6.55504032 8.94837702,6.80321573 L11.7758972,9.68415323 C12.0146875,9.92922379 12.0146875,10.3187399 11.7758972,10.5638105 L9.05203629,13.3379133 C8.81014113,13.5860887 8.41116935,13.5892641 8.16299395,13.3472984 C7.91481855,13.1053327 7.91164315,12.7064315 8.15671371,12.458256 L10.4469556,10.1239819 L8.04987903,7.68287298 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPageRightDis);
export default __webpack_public_path__ + "static/media/icon_page_right_dis.2aa24cb70f32e28ce42b7dc1bd23439b.svg";
export { ForwardRef as ReactComponent };